export default __webpack_public_path__ + "static/media/filter-blue.0cb74f95.svg";